<template>
  <v-select
    :model-value="modelValue"
    :items="filteredItems"
    :menu-props="{ maxHeight: '300' }"
    class="filter-menu"
    menu-icon="icon-arrow-down-xs"
    :class="{ 'cui-filter-active': modelValue?.length }"
    :placeholder="$t('manageWorkspaces.filters.labels')"
    density="compact"
    variant="outlined"
    multiple
    rounded
    item-value="id"
    item-title="name"
    :disabled="disabled"
    :clearable="clearable"
    clear-icon="icon-rules-close"
    @update:model-value="$emit('update:modelValue', $event)"
    @update:menu="search = ''"
  >
    <template #prepend-item>
      <cui-select-search-field
        v-model="search"
        :placeholder="$t('general.search')"
        data-test-id="workspace-labels-select-search"
      />
    </template>
    <template #selection="{ index }">
      <span v-if="index === 0" class="body2">{{ $t("manageWorkspaces.filters.labels") }}</span>
    </template>
    <template #label>
      <span v-if="modelValue.length" class="filter-label">{{ modelValue.length }}</span>
    </template>
    <template #item="{ item, props }">
      <v-list-item v-bind="props">
        <template v-slot:prepend="{ isActive }">
          <v-list-item-action start>
            <v-checkbox-btn density="compact" :model-value="isActive"></v-checkbox-btn>
          </v-list-item-action>
        </template>

        <template v-slot:title>
          <div class="d-flex align-center label-popup-block">
            <div class="color-preview mr-2" :style="{ 'background-color': item.raw.color }" />
            <span>{{ item.raw.name }}</span>
          </div>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { MspLabel } from "@/_store/msp/msp-labels.module.ts";
import { CuiSelectSearchField, useCuiSelectSearch } from "@coronet/cui";

export default defineComponent({
  components: { CuiSelectSearchField },
  props: {
    modelValue: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    items: {
      type: Array as PropType<MspLabel[]>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props) {
    const { search, filteredItems } = useCuiSelectSearch(
      () => props.items,
      (item) => item.name
    );

    return { search, filteredItems };
  },
});
</script>

<style scoped lang="scss">
.color-preview {
  width: 20px;
  max-width: 20px;
  height: 20px;
  border-radius: 4px;
}
</style>
